import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWheelchairNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4 4a4 4 0 103.996 4.183l3.015 1.085a2.5 2.5 0 10.876-1.678l-.41-1.417A1.625 1.625 0 009.914 5H9v1.25h.915c.167 0 .314.11.36.27l.374 1.29-2.836-1.022A4.002 4.002 0 004 4zM1.25 8a2.75 2.75 0 015.22-1.211l-3.22.743.282 1.218 3.218-.743A2.75 2.75 0 011.25 8zm11.02 1.721l1.606.579.424-1.176-1.607-.579a1.25 1.25 0 11-.424 1.176z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWheelchairNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWheelchairNormalXsmall;
